/* eslint-disable react/prop-types */
import React, { CSSProperties } from 'react';
import Style from './index.less';
import PStyle from './../palette-panel/palette/index.less';
import classNames from 'classnames';
import { ActionType } from '../../../editor/src/js/constants/common-action-type';
import SubMenu from './sub-menu';
import Arrow from '../../../editor/src/img/menu/arrow.svg';
import ShapeMenu from '../shape-pick-menu';
import { TOOLBAR_CROP_SHAPE, TOOLBAR_CROP_WH, TOOLBAR_CROP } from '../../../editor/src/img/pageIndex/index';
import i18n from '@i18next/i18n';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

const ItemData = [
    { id: ActionType.TAILOR_PIC_NORMAL, title: i18n.t('裁剪'), icon: TOOLBAR_CROP },
    {
        id: ActionType.TAILOR_PIC_SHAPE, title: i18n.t('裁剪为形状'), icon: TOOLBAR_CROP_SHAPE, showArrow: true, shapeMenu: ShapeMenu,
    },
    {
        id: ActionType.TAILOR_PIC_WH, title: i18n.t('裁剪为纵横比'), icon: TOOLBAR_CROP_WH, showArrow: true, content: SubMenu,
    },
];

const DEFAULT_INDEX = -1;

interface CropPanelProps {
    handleClick?: (id) => void;
    hideMenu?: () => void;
}

interface CropPanelState {
    isShown: boolean;
    showRight: boolean;
    x: number;
    y: number;
    value?: any;
}

export default class CropPanel extends React.Component<CropPanelProps, CropPanelState> {
    private isEditing: boolean;
    private listArray: typeof ItemData;
    private shapeRef: HTMLDivElement|null;
    private whRef: HTMLDivElement|null;
    private setted: boolean;
    public constructor(props, context) {
        super(props, context);

        this.state = {
            isShown: false,
            showRight: true,
            x: 0,
            y: 0,
        };
    }

    public componentWillUnmount() {
        this.getEditingStateManager().isEditing = false;
        this.isEditing = false;
    }

    public render() {
        this.listArray = ItemData;

        const listItemClass = classNames({
            [PStyle['text-font']]: true,
            [PStyle['list-item-text']]: true,
        });

        const display = 'flex';
        const panelStyle = {
            display, left: this.state.x, top: this.state.y, width: '140px',
        };

        // 计算子菜单位置
        const { showRight } = this.state;
        const width = 140;
        const subStyle = showRight ? { left: width - 2, right: '' } : { left: 'auto', right: width - 2 };

        const vh = document.body.clientHeight;

        const subStyleShape: CSSProperties = {
            ...subStyle,
            boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
            border: '1px solid #e7e7e7',
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            borderBottomLeftRadius: '3px',
            borderBottomRightRadius: '3px',
            maxHeight: `${vh - this.state.y - 44 - 16}px`,
            overflowY: 'scroll',
        };

        const whh = (vh - this.state.y - 76 - 16);
        let subStyleWH: CSSProperties = {
            ...subStyle,
            boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
            border: '1px solid #e7e7e7',
            borderTopLeftRadius: '3px',
            borderTopRightRadius: '3px',
            borderBottomLeftRadius: '3px',
            borderBottomRightRadius: '3px',
        };

        if (whh < 448) {
            subStyleWH = {
                ...subStyleWH,
                maxHeight: `${vh - this.state.y - 76 - 16}px`,
                overflowY: 'scroll',
            };
        }
        const disableItems = this.getMenuManager()?.disableItemIds();

        return (
            <div className={Style['crop-panel']} style={panelStyle}>
                {this.listArray.length > 0 ? <ul className={PStyle['palette-list']} onMouseEnter={this.handleListMouseEnter}>
                    {this.listArray.map((item) => {
                        const Content = item.content;
                        const { shapeMenu } = item;
                        const disableClassName = disableItems?.findIndex(disableItem => disableItem.id === item.id) !== DEFAULT_INDEX ? PStyle['list-item-disable'] : '';
                        return <li className={`${PStyle['list-item']} ${item.showArrow ? PStyle['list-item-sub'] : ''} ${disableClassName}`} key={item.title} onClick={() => this.handleItemClick(event, item.id)} onMouseDown={this.preventBlur}>
                            <img src={item.icon} className={PStyle['list-item-img']}/>
                            <span className = {listItemClass}>{item.title}</span>
                            {item.showArrow ? <img src={Arrow} className={PStyle['list-item-arrow']}/> : null}
                            {Content ? <div ref={(el) => {
                                this.whRef = el;
                            }}  className={`${PStyle['palette-sub-menu']} menu-scroll`} style={subStyleWH}><Content id={item.id} handleMenuClick={this.handleSubItemClick} border={this.state.value}/></div> : null}
                            {shapeMenu ? <div ref={(el) => {
                                this.shapeRef = el;
                            }} className={`${PStyle['palette-sub-menu']} menu-scroll`} style={subStyleShape}><ShapeMenu
                                    hideMenu={this.hideMenu}
                                    cropPicker={true}
                                />
                            </div>
                                :  null
                            }
                        </li>;
                    })}
                </ul> : null}

            </div>
        );
    }

    private hide = () => {
        if (this.isEditing) {
            return;
        }
        if (this.state.isShown) {
            this.setState({
                isShown: false,
            }, () => {

            });
        }
        this.getToolbarStateManager().isToolbarMenuShown = false;
    };

    private handleListMouseEnter = (e) => {
        if (e.currentTarget && !this.setted) {
            const dom = e.currentTarget;
            const rect = dom.getBoundingClientRect();
            const y = rect.top + 4;

            const vh = document.body.clientHeight;
            const shapeHeight =  (vh - y - 44 - 16);
            if (this.shapeRef) {
                this.shapeRef.style.maxHeight = `${shapeHeight}px`;
            }

            const whHeight = (vh - y - 76 - 16);
            if (this.whRef) {
                this.whRef.style.maxHeight = `${whHeight}px`;
            }

            this.setted = true;
        }
    };

    private handleItemClick = (e, id) => {
        if (id === ActionType.TAILOR_PIC_NORMAL) {
            const { selectedArray } = this.getSelectionService().selectedElements;
            if (selectedArray?.length === 1) {
                this.props.handleClick?.(id);
            }
            this.hide();
        }
    };

    private handleSubItemClick = (item) => {
        const { selectedArray } = this.getSelectionService().selectedElements;
        if (selectedArray?.length === 1) {
            this.props.handleClick?.(item.id);
        }
        this.hide();
    };

    private preventBlur = (e) => {
        e.preventDefault();     // 配合onMouseDown，不触发blur
    };

    private hideMenu = () => {
        if (this.props.hideMenu) {
            this.props.hideMenu();
        }
    };

    private getSelectionService = () => this.getAppServices().viewableServiceLayer?.selectionService;

    private getEditingStateManager = () => this.getAppServices().viewableServiceLayer.editingStateManager;

    private getMenuManager = () => this.getAppServices().editableServiceLayer?.menuManager;

    private getToolbarStateManager = () => this.getAppServices().viewableServiceLayer.toolbarStateManager;

    private getAppServices() {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}
